import {
  CLEAR_MOVE_MODAL_FOLDERS,
  MOVE_MODAL_CREATE_NEW_FOLDER_HIDE,
  MOVE_MODAL_CREATE_NEW_FOLDER_SHOW,
  MOVE_MODAL_CREATE_NEW_FOLDER_SUCCESS,
  MOVE_MODAL_UPDATE_FOLDER_TO_MOVE_TO,
  MOVE_MODAL_UPDATE_NEW_FOLDER_NAME,
  TOGGLE_MOVE_MODAL,
  UPDATE_FETCHING_MOVE_MODAL_TOP_LEVEL_FOLDER,
  UPDATE_MOVE_MODAL_FOLDERS,
  UPDATE_MOVE_MODAL_TOP_LEVEL_FOLDER,
} from 'constants/actions';

const DEFAULT_MOVE_MODAL_STATE = {
  items: [],
  folders: [],
  topLevelFolder: null,
  isFetchingInitialFolders: true,
  folderToMoveTo: {},
  newFolderName: 'Untitled',
  showNewFolderInput: false,
  showMoveModal: false,
};

const moveModalReducer = (state = DEFAULT_MOVE_MODAL_STATE, action) => {
  switch (action.type) {
    case CLEAR_MOVE_MODAL_FOLDERS:
      return {
        ...state,
        topLevelFolder: null,
        folders: [],
        isFetchingInitialFolders: true,
        folderToMoveTo: {},
      };
    case UPDATE_MOVE_MODAL_FOLDERS:
      return {
        ...state,
        folders: action.folders,
        isFetchingInitialFolders: false,
      };
    case UPDATE_MOVE_MODAL_TOP_LEVEL_FOLDER:
      return {
        ...state,
        topLevelFolder: action.folder,
      };
    case UPDATE_FETCHING_MOVE_MODAL_TOP_LEVEL_FOLDER:
      return {
        ...state,
        isFetchingInitialFolders: action.isFetching,
      };
    case TOGGLE_MOVE_MODAL:
      return {
        ...state,
        showMoveModal: action.show,
        ...(!action.show && { items: [] }),
        ...(action.items && { items: [...action.items] }),
      };
    case MOVE_MODAL_UPDATE_FOLDER_TO_MOVE_TO:
      return {
        ...state,
        folderToMoveTo:
          action.folder || DEFAULT_MOVE_MODAL_STATE.folderToMoveTo,
      };
    case MOVE_MODAL_CREATE_NEW_FOLDER_SHOW:
      return {
        ...state,
        showNewFolderInput: true,
      };
    case MOVE_MODAL_CREATE_NEW_FOLDER_HIDE:
      return {
        ...state,
        showNewFolderInput: false,
        newFolderName: DEFAULT_MOVE_MODAL_STATE.newFolderName,
      };
    case MOVE_MODAL_UPDATE_NEW_FOLDER_NAME:
      return { ...state, newFolderName: action.name };
    case MOVE_MODAL_CREATE_NEW_FOLDER_SUCCESS:
      return {
        ...state,
        showNewFolderInput: false,
        newFolderName: DEFAULT_MOVE_MODAL_STATE.newFolderName,
        folderToMoveTo: action.folder,
        folders: [{ ...action.folder, isTopLevel: true }, ...state.folders],
      };
    default:
      return {
        ...state,
      };
  }
};

export default moveModalReducer;
